export default __webpack_public_path__ + "static/equitrip-a55aee94ed6456a37a9ed1bac9516ac5.webp";